import {useState} from "react";

import {Post, TreeNode} from "../../../types/Post";
import {CONTENT_MANAGEMENT_MODAL_CONTENT} from "../components/ContentManagementModalContent";

export const useContentManagementState = () => {
  const [selectedCategory, setSelectedCategory] = useState<TreeNode | null>(null);
  const [dialogContent, setDialogContent] = useState<CONTENT_MANAGEMENT_MODAL_CONTENT | "">("");
  const [editingPost, setEditingPost] = useState<Post | null>(null);

  const openEdit = (post: Post) => {
    setEditingPost(post);
    setDialogContent(CONTENT_MANAGEMENT_MODAL_CONTENT.POST);
  };

  const openCreatePost = () => {
    setEditingPost(null);
    setDialogContent(CONTENT_MANAGEMENT_MODAL_CONTENT.POST);
  };

  const handleCloseDialog = () => {
    setDialogContent("");
  };

  const handleSelectCategory = (category: TreeNode) => {
    setSelectedCategory(category);
  };

  const handleRenameCategory = (category: TreeNode) => {
    setSelectedCategory(category);
    setDialogContent(CONTENT_MANAGEMENT_MODAL_CONTENT.RENAME);
  };

  const handleAddCategory = (category: TreeNode) => {
    setSelectedCategory(category);
    setDialogContent(CONTENT_MANAGEMENT_MODAL_CONTENT.ADD);
  };

  const handleDeleteCategoryDialog = (category: TreeNode) => {
    setSelectedCategory(category);
    setDialogContent(CONTENT_MANAGEMENT_MODAL_CONTENT.CONFIRM_DELETE);
  };

  const handleMoveCategoryDialog = (category: TreeNode) => {
    setSelectedCategory(category);
    setDialogContent(CONTENT_MANAGEMENT_MODAL_CONTENT.MOVE);
  };

  const handleChangeCoverDialog = (category: TreeNode) => {
    setSelectedCategory(category);
    setDialogContent(CONTENT_MANAGEMENT_MODAL_CONTENT.CHANGE_COVER);
  };

  const handleDeletePostDialog = async () => {
    setDialogContent(CONTENT_MANAGEMENT_MODAL_CONTENT.CONFIRM_DELETE_POST);
  };

  return {
    selectedCategory,
    dialogContent,
    editingPost,
    setSelectedCategory,
    setDialogContent,
    openEdit,
    openCreatePost,
    handleCloseDialog,
    handleSelectCategory,
    handleRenameCategory,
    handleAddCategory,
    handleDeleteCategoryDialog,
    handleMoveCategoryDialog,
    handleChangeCoverDialog,
    handleDeletePostDialog,
  };
};
